//TESTING
export const INCREMENT = "INCREMENT"
export const DECREMENT = "DECREMENT"
export const RESET = "RESET"
//INITIAL DATA
export const LOAD_API_INITIAL_DATA = "LOAD_API_INITIAL_DATA"
export const LOAD_API_INITIAL_DATA_FAILED = "LOAD_API_INITIAL_DATA_FAILED"
export const LOAD_API_INITIAL_DATA_SUCCESS = "LOAD_API_INITIAL_DATA_SUCCESS"
//SERVICE DATA
export const LOAD_API_SERVICE_DATA = "LOAD_API_SERVICE_DATA"
export const LOAD_API_SERVICE_DATA_FAILED = "LOAD_API_SERVICE_DATA_FAILED"
export const LOAD_API_SERVICE_DATA_SUCCESS = "LOAD_API_SERVICE_DATA_SUCCESS"

//SERVICE DETAIL DATA
export const LOAD_API_SERVICE_DETAIL_DATA = "LOAD_API_SERVICE_DETAIL_DATA"
export const LOAD_API_SERVICE_DETAIL_FAILED = "LOAD_API_SERVICE_DETAIL_FAILED"
export const LOAD_API_SERVICE_DETAIL_SUCCESS = "LOAD_API_SERVICE_DETAIL_SUCCESS"

//COMMENTS DATA
export const LOAD_API_COMMENT_DATA = "LOAD_API_COMMENT_DATA"
export const LOAD_API_COMMENT_DATA_FAILED = "LOAD_API_COMMENT_DATA_FAILED"
export const LOAD_API_COMMENT_DATA_SUCCESS = "LOAD_API_COMMENT_DATA_SUCCESS"

//INITIAL DATA MODAL
export const INITIAL_DATA_LOADED = "INITIAL_DATA_LOADED"

//SERVICETYPES DATA
export const LOAD_API_SERVICETYPES_INFO_DATA = "LOAD_API_SERVICETYPES_INFO_DATA"
export const LOAD_API_SERVICETYPES_INFO_DATA_FAILED = "LOAD_API_SERVICETYPES_INFO_DATA_FAILED"
export const LOAD_API_SERVICETYPES_INFO_DATA_SUCCESS = "LOAD_API_SERVICETYPES_INFO_DATA_SUCCESS"

//TRANSPORT DATA
export const LOAD_API_TRANSPORT_INFO_DATA = "LOAD_API_TRANSPORT_INFO_DATA"
export const LOAD_API_TRANSPORT_INFO_DATA_FAILED = "LOAD_API_TRANSPORT_INFO_DATA_FAILED"
export const LOAD_API_TRANSPORT_INFO_DATA_SUCCESS = "LOAD_API_TRANSPORT_INFO_DATA_SUCCESS"

//REMOVE BOOKING FROM SERVICE
export const REMOVE_API_BOOKING_FROM_SERVICE = "REMOVE_API_BOOKING_FROM_SERVICE"
export const REMOVE_API_BOOKING_FROM_SERVICE_FAILED = "REMOVE_API_BOOKING_FROM_SERVICE_FAILED"
export const REMOVE_API_BOOKING_FROM_SERVICE_SUCCESS = "REMOVE_API_BOOKING_FROM_SERVICE_SUCCESS"

//FOOTER STATUS
export const UPDATE_FOOTER_COUNTERS_LOADING = "UPDATE_FOOTER_COUNTERS_LOADING"
export const UPDATE_FOOTER_COUNTERS_FAILED = "UPDATE_FOOTER_COUNTERS_FAILED"
export const UPDATE_FOOTER_COUNTERS_SUCCESS = "UPDATE_FOOTER_COUNTERS_SUCCESS"
export const RESET_SELECTED_SECTION = "RESET_SELECTED_SECTION"

//BOOKING SEARCH
export const ACTIVATE_BOOKING_BY_QR_LOADING = "ACTIVATE_BOOKING_BY_QR_LOADING"
export const ACTIVATE_BOOKING_BY_QR_FAILED = "ACTIVATE_BOOKING_BY_QR_FAILED"
export const ACTIVATE_BOOKING_BY_QR_SUCCESS = "ACTIVATE_BOOKING_BY_QR_SUCCESS"

//DISPATCH SERVICE
export const DISPATCH_SERVICE_LOADING = "DISPATCH_SERVICE_LOADING"
export const DISPATCH_SERVICE_FAILED = "DISPATCH_SERVICE_FAILED"
export const DISPATCH_SERVICE_SUCCESS = "DISPATCH_SERVICE_SUCCESS"

//RETRY DIAPTCH SERVICE
export const RETRY_DISPATCH_SERVICE_LOADING = "RETRY_DISPATCH_SERVICE_LOADING"
export const RETRY_DISPATCH_SERVICE_FAILED = "RETRY_DISPATCH_SERVICE_FAILED"
export const RETRY_DISPATCH_SERVICE_SUCCESS = "RETRY_DISPATCH_SERVICE_SUCCESS"

//ARRIVE SERVICE
export const ARRIVE_SERVICE_LOADING = "ARRIVE_SERVICE_LOADING"
export const ARRIVE_SERVICE_FAILED = "ARRIVE_SERVICE_FAILED"
export const ARRIVE_SERVICE_SUCCESS = "ARRIVE_SERVICE_SUCCESS"
export const ARRIVE_SERVICE_RESET = "ARRIVE_SERVICE_RESET"

//TRANSPORT CHANGE
export const TRANSPORT_CHANGE_LOADING = "TRANSPORT_CHANGE_LOADING"
export const TRANSPORT_CHANGE_FAILED = "TRANSPORT_CHANGE_FAILED"
export const TRANSPORT_CHANGE_SUCCESS = "TRANSPORT_CHANGE_SUCCESS"

//FOOTER COUNTERS REFRESH
export const FOOTER_COUNTERS_REFRESH_FAILED = "FOOTER_COUNTERS_REFRESH_FAILED"
export const FOOTER_COUNTERS_REFRESH_LOADING = "FOOTER_COUNTERS_REFRESH_LOADING"
export const FOOTER_COUNTERS_REFRESH_SUCCESS = "FOOTER_COUNTERS_REFRESH_SUCCESS"

//DEPARTURE FOOTER COUNTERS REFRESH
export const DEPARTURE_FOOTER_COUNTERS_REFRESH_FAILED = "DEPARTURE_FOOTER_COUNTERS_REFRESH_FAILED"
export const DEPARTURE_FOOTER_COUNTERS_REFRESH_LOADING = "DEPARTURE_FOOTER_COUNTERS_REFRESH_LOADING"
export const DEPARTURE_FOOTER_COUNTERS_REFRESH_SUCCESS = "DEPARTURE_FOOTER_COUNTERS_REFRESH_SUCCESS"

//ACTIVATE SERVICE
export const ACTIVATE_SERVICE_LOADING = "ACTIVATE_SERVICE_LOADING"
export const ACTIVATE_SERVICE_FAILED = "ACTIVATE_SERVICE_FAILED"
export const ACTIVATE_SERVICE_SUCCESS = "ACTIVATE_SERVICE_SUCCESS"

//ADD_SERVICE_BOOKING
export const ADD_SERVICE_BOOKING_LOADING = "ADD_SERVICE_BOOKING_LOADING"
export const ADD_SERVICE_BOOKING_FAILED = "ADD_SERVICE_BOOKING_FAILED"
export const ADD_SERVICE_BOOKING_SUCCESS = "ADD_SERVICE_BOOKING_SUCCESS"

//CREATE_SERVICE
export const CREATE_SERVICE_LOADING = "CREATE_SERVICE_LOADING"
export const CREATE_SERVICE_FAILED = "CREATE_SERVICE_FAILED"
export const CREATE_SERVICE_SUCCESS = "CREATE_SERVICE_SUCCESS"

//SERVICE_COMMENTS
export const SERVICE_COMMENTS_LOADING = "SERVICE_COMMENTS_LOADING"
export const SERVICE_COMMENTS_FAILED = "SERVICE_COMMENTS_FAILED"
export const SERVICE_COMMENTS_SUCCESS = "SERVICE_COMMENTS_SUCCESS"

//UNASSIGNED_BOOKINGS
export const UNASSIGNED_BOOKINGS_LOADING = "UNASSIGNED_BOOKINGS_LOADING"
export const UNASSIGNED_BOOKINGS_FAILED = "UNASSIGNED_BOOKINGS_FAILED"
export const UNASSIGNED_BOOKINGS_SUCCESS = "UNASSIGNED_BOOKINGS_SUCCESS"

//UNASSIGNED_BOOKINGS
export const DEPARTURE_UA_BOOKINGS_LOADING = "DEPARTURE_UA_BOOKINGS_LOADING"
export const DEPARTURE_UA_BOOKINGS_FAILED = "DEPARTURE_UA_BOOKINGS_FAILED"
export const DEPARTURE_UA_BOOKINGS_SUCCESS = "DEPARTURE_UA_BOOKINGS_SUCCESS"

//REALTIME_UNASSIGNED_BOOKINGS_NOTIFICATION
export const REALTIME_UNASSIGNED_BOOKING_NOTIFICATION_SUCCESS = "REALTIME_UNASSIGNED_BOOKING_NOTIFICATION_SUCCESS"

//PAX
export const PAX_LOADING = "PAX_LOADING"
export const PAX_FAILED = "PAX_FAILED"
export const PAX_SUCCESS = "PAX_SUCCESS"

// DELETE BOOKING
export const DELETE_B_LOADING = "DELETE_B_LOADING"
export const DELETE_B_FAILED = "DELETE_B_FAILED"
export const DELETE_B_SUCCESS = "DELETE_B_SUCCESS"

// CHANGE HEADER EXTRA SERVICE
export const CHANGE_HEADER_LOADING = "CHANGE_HEADER_LOADING"
export const CHANGE_HEADER_FAILED = "CHANGE_HEADER_FAILED"
export const CHANGE_HEADER_SUCCESS = "CHANGE_HEADER_SUCCESS"

//REALTIME UPDATE SERVICE
export const REALTIME_UPDATE_SERVICE_LOADING = "REALTIME_UPDATE_SERVICE_LOADING"
export const REALTIME_UPDATE_SERVICE_FAILED = "REALTIME_UPDATE_SERVICE_FAILED"
export const REALTIME_UPDATE_SERVICE_SUCCESS = "REALTIME_UPDATE_SERVICE_SUCCESS"

//REALTIME UPDATE DEPARTURE
export const REALTIME_UPDATE_DEPARTURE_LOADING = "REALTIME_UPDATE_DEPARTURE_LOADING"
export const REALTIME_UPDATE_DEPARTURE_FAILED = "REALTIME_UPDATE_DEPARTURE_FAILED"
export const REALTIME_UPDATE_DEPARTURE_SUCCESS = "REALTIME_UPDATE_DEPARTURE_SUCCESS"

//REALTIME DEPARTURE POSITION (map-only lightweight updates)
export const REALTIME_DEPARTURE_POSITION_SUCCESS = "REALTIME_DEPARTURE_POSITION_SUCCESS"

//MASTER DATA SERVICE
export const MASTER_DATA_SERVICE_LOADING = "MASTER_DATA_SERVICE_LOADING"
export const MASTER_DATA_SERVICE_FAILED = "MASTER_DATA_SERVICE_FAILED"
export const MASTER_DATA_SERVICE_SUCCESS = "MASTER_DATA_SERVICE_SUCCESS"

//DEPARTURE DATA
export const LOAD_API_DEPARTURE_DATA = "LOAD_API_DEPARTURE_DATA"
export const LOAD_API_DEPARTURE_FAILED = "LOAD_API_DEPARTURE_FAILED"
export const LOAD_API_DEPARTURE_SUCCESS = "LOAD_API_DEPARTURE_SUCCESS"

//DEPARTURE BOOKINGS
export const GET_BOOKING_DEPARTURE_LOADING = "GET_BOOKING_DEPARTURE_LOADING"
export const GET_BOOKING_DEPARTURE_FAILED = "GET_BOOKING_DEPARTURE_FAILED"
export const GET_BOOKING_DEPARTURE_SUCCESS = "GET_BOOKING_DEPARTURE_SUCCESS"

//FOOTER STATUS
export const UPDATE_DEPARTURE_FOOTER_COUNTERS_LOADING = "UPDATE_DEPARTURE_FOOTER_COUNTERS_LOADING"
export const UPDATE_DEPARTURE_COUNTERS_FAILED = "UPDATE_DEPARTURE_COUNTERS_FAILED"
export const UPDATE_DEPARTURE_COUNTERS_SUCCESS = "UPDATE_DEPARTURE_COUNTERS_SUCCESS"

//FILTER DATA
export const LOAD_FILTER_DATA_LOADING = "LOAD_FILTER_DATA_LOADING"
export const LOAD_FILTER_DATA_FAILED = "LOAD_FILTER_DATA_FAILED"
export const LOAD_FILTER_DATA_SUCCESS = "LOAD_FILTER_DATA_SUCCESS"

//OPERATION TYPES
export const OPERATION_TYPES_DATA_LOADING = "OPERATION_TYPES_DATA_LOADING"
export const OPERATION_TYPES_DATA_FAILED = "OPERATION_TYPES_DATA_FAILED"
export const OPERATION_TYPES_DATA_SUCCESS = "OPERATION_TYPES_DATA_SUCCESS"

//POST SHOW BOOKING
export const POST_SHOW_BOOKING_LOADING = "POST_SHOW_BOOKING_LOADING"
export const POST_SHOW_BOOKING_FAILED = "POST_SHOW_BOOKING_FAILED"
export const POST_SHOW_BOOKING_SUCCESS = "POST_SHOW_BOOKING_SUCCESS"
export const POST_SHOW_BOOKING_RESET = "POST_SHOW_BOOKING_RESET"

//POST NO SHOW BOOKING
export const POST_NO_SHOW_BOOKING_LOADING = "POST_NO_SHOW_BOOKING_LOADING"
export const POST_NO_SHOW_BOOKING_FAILED = "POST_NO_SHOW_BOOKING_FAILED"
export const POST_NO_SHOW_BOOKING_SUCCESS = "POST_NO_SHOW_BOOKING_SUCCESS"
export const POST_NO_SHOW_BOOKING_RESET = "POST_NO_SHOW_BOOKING_RESET"

//END_DEPARTURE_SERVICE
export const END_DEPARTURE_SERVICE_SUCCESS = "END_DEPARTURE_SERVICE_SUCCESS"
export const END_DEPARTURE_SERVICE_FAILED = "END_DEPARTURE_SERVICE_FAILED"
export const END_DEPARTURE_SERVICE_LOADING = "END_DEPARTURE_SERVICE_LOADING"

//START_DEPARTURE_SERVICE
export const START_DEPARTURE_SERVICE_SUCCESS = "START_DEPARTURE_SERVICE_SUCCESS"
export const START_DEPARTURE_SERVICE_FAILED = "START_DEPARTURE_SERVICE_FAILED"
export const START_DEPARTURE_SERVICE_LOADING = "START_DEPARTURE_SERVICE_LOADING"

//SHOW_TOAST
export const SHOW_INFO_TOAST = "SHOW_INFO_TOAST"
export const SHOW_ERROR_TOAST = "SHOW_ERROR_TOAST"
export const SHOW_WARNING_TOAST = "SHOW_WARNING_TOAST"

//VEHICLE CONTRACTS
export const GET_VEHICLE_CONTRACTS_LOADING = "GET_VEHICLE_CONTRACTS_LOADING"
export const GET_VEHICLE_CONTRACTS_FAILED = "GET_VEHICLE_CONTRACTS_FAILED"
export const GET_VEHICLE_CONTRACTS_SUCCESS = "GET_VEHICLE_CONTRACTS_SUCCESS"